import styled from 'styled-components';
import { ActionButton } from '@womcorp/wom-miwom-ui-kit/dist/components/Button';

const RoamingContainerStyled = styled.div`
  height: fit-content;
  background: #fff;
  border-radius: 8px;
  min-width: 100%;
  padding-bottom: 8px;
  margin-bottom: 24px;
`;

const RoamingHeaderStyled = styled.div`
  padding: 16px;
  border-bottom: 1px solid #e2e6ea;
  & > h1 {
    font-weight: 700;
    font-size: 18px;
    line-height: 20px;
    color: #0e141d;
  }

  & > h2 {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #494c66;
  }
`;

const RoamingContentStyled = styled.div`
  padding: 24px 16px 8px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  row-gap: 16px;
  column-gap: 8px;
  max-width: 400px;
  margin: auto;
`;

const ActionButtonWrapperStyled = styled.div`
  grid-column: ${({ centerbutton }) => (centerbutton ? '2/3;' : '')};

  ${RoamingContentStyled} & {
    border: 1px solid #e2e6ea;
    position: relative;
    border-radius: 8px;
    height: 92px;

    :hover {
      border-color: #4d008c;
    }

    svg {
      width: 40px;
      height: 40px;
      margin-bottom: 4px;
    }

    @media (min-width: 769px) {
      width: 128px;
    }
  }

  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #0e141d;
  }
`;

const ActionButtonStyled = styled(ActionButton)`
  width: 100%;
  height: 100%;

  :before {
    background: #dbcce8;
    border-radius: 4px;
    content: ${({ $isNew }) => ($isNew ? `'Nuevo'` : 'none')};
    color: #4d008c;
    font-size: 11px;
    line-height: 16px;
    padding: 0 4px;
    position: absolute;
    top: -8px;
  }
`;

export {
  RoamingContainerStyled,
  RoamingHeaderStyled,
  RoamingContentStyled,
  ActionButtonStyled,
  ActionButtonWrapperStyled,
};
